import React from "react";
import { FiChevronRight } from "react-icons/fi";
import CarCrashIcon from "@mui/icons-material/CarCrash";
import { AssetMovement } from "../../../../../logic/api";
import { countVehicleIssues } from "../../../../../utility/assetIssues";
import { useDate } from "../../../../../utility/useDate";
import { fullVehicleDescription, locationDescription } from "../condensedLayoutUtils";
import styles from "../styles";
import { useTranslation } from "react-i18next";

const AssetMovementRow: React.FunctionComponent<{
    assetMovement: AssetMovement,
    movementCategory: number,
    rowIndex: number,
    onClick: () => void
}> = (props) => {
    const { toFormattedFullDateTimeString } = useDate();
    const { assetMovement, rowIndex } = props;
    const { movedBy, movementDate, booking } = assetMovement;
    const { ref, vehicle, vehicleAuditIssues } = booking;
    const { t } = useTranslation();

    const rowStyles = {
        ...(rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven),
        cursor: "pointer",
    };

    // TODO: Update movement direction when data is available, currently it's always "in"
    return (<tr style={rowStyles} onClick={props.onClick}>
        <td style={styles.tableCell}>{t("locations.in")}</td>
        <td style={styles.tableCell}>{ref}</td>
        <td style={styles.tableCell}>{locationDescription(assetMovement.location)}</td>
        <td style={styles.tableCell}>{vehicle.registration}</td>
        <span style={{ ...styles.tableCell, display: "inline-block", marginLeft: -32, marginTop: 4, width: 32 }}>{countVehicleIssues(vehicleAuditIssues) ? <CarCrashIcon style={{ color: "rgb(235, 48, 79)" }} /> : ""}</span>
        <td style={styles.tableCell}>{fullVehicleDescription(vehicle)}</td>
        <td style={styles.tableCell}>{`${movedBy.firstName} ${movedBy.lastName}`}</td>
        <td style={styles.tableCell}>{toFormattedFullDateTimeString(new Date(movementDate))}</td>
        <td style={styles.tableCell}><FiChevronRight /></td>
    </tr>);
}

export default AssetMovementRow;
